import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import DeliveryRateModal from '../../AddOrUpdate/components/TerritoryModal';

const TerritoryDetailsView = ({ reactTableData, dataInfo, isNoRecordFound }) => {
  const [rows, setData] = useState(reactTableData && reactTableData?.tableRowsData ? reactTableData.tableRowsData : null);
  const { t } = useTranslation('common');

  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Territory Name ...',
  };
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const Add = () => {
    setViewDetailPopup(true);
    setTitle("Add Delivery Territory");
  }
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Delivery Territory Details</h3>
            </Col>
          </Row>
          <Tooltip title="Click here to add new details">
            <Fab size="large" color="primary" aria-label="add" style={{ float: "right", backgroundColor: "#32CA73", color: "white" }} onClick={() => Add()}>
              <AddIcon />
            </Fab>
          </Tooltip>
          {!isNoRecordFound && rows &&
            <ReactTableBase
              name={t('instution_type.view.name_map')}
              key={'searchable'}
              columns={reactTableData.tableHeaderData}
              data={rows}
              tableConfig={tableConfig}
            />
          }
          {viewDetailPopup &&
            <DeliveryRateModal
              modalShow={viewDetailPopup}
              setModalShow={setViewDetailPopup}
              dataInfo={dataInfo}
              isTitle={isTitle} />}
        </CardBody>
      </Card>
    </Col>
  );
};

TerritoryDetailsView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default TerritoryDetailsView;
